import React, {useState, useEffect} from 'react';
import {Switch, Redirect} from 'react-router-dom';
import {RouteWithLayout} from './components';
import {NotFoundView} from 'lib.front';
import {Minimal as MinimalLayout, Main as MainLayout} from './layouts';
import {SCRN_DASHBOARD, SCRN_LOG_IN, SCRN_NOT_FOUND} from './constants/screens';
import {Dashboard as DashboardView, SignIn as SignInView} from './views';
import {defaultRoute} from './config/keys';

function Routes(props) {
   const {logged} = props;
   const [esProduccion, setEsProduccion] = useState(false);
   useEffect(() => {
      setEsProduccion(
         !process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DS_ENV === 'PROD'
      );
   }, []);
   const defaultPath = logged ? defaultRoute : SCRN_LOG_IN;

   return (
      <Switch>
         <Redirect exact from="/" to={defaultPath} />
         <RouteWithLayout
            component={DashboardView}
            exact
            layout={MainLayout}
            path={SCRN_DASHBOARD}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={SignInView}
            exact
            layout={MinimalLayout}
            path={SCRN_LOG_IN}
            condition={!logged}
         />
         <RouteWithLayout
            component={NotFoundView}
            exact
            layout={logged ? MainLayout : MinimalLayout}
            path={SCRN_NOT_FOUND}
         />
         <Redirect to={SCRN_NOT_FOUND} />
      </Switch>
   );
}

export default Routes;
